export default "__VITE_ASSET__BF3m8yvs__"